<script setup>
import {onBeforeUnmount, onBeforeMount} from "vue";
import {useStore} from "vuex";
// import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import loginImage from "@/assets/img/login.jpg";

const body = document.getElementsByTagName("body")[0];

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;

  store.state.isRTL = true;
  document.querySelector("html").setAttribute("lang", "fa");
  document.querySelector("html").setAttribute("dir", "rtl");
  // document.querySelector("#app").classList.add("rtl");

  body.classList.remove("bg-gray-100");


});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;

  store.state.isRTL = false;
  document.querySelector("html").removeAttribute("lang");
  document.querySelector("html").removeAttribute("dir");
  document.querySelector("#app").classList.remove("rtl");

  body.classList.add("bg-gray-100");
});



</script>
<template>
  <!--  <div class="container top-0 position-sticky z-index-sticky">-->
  <!--    <div class="row">-->
  <!--      <div class="col-12">-->
  <!--        <navbar-->
  <!--          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"-->
  <!--          v-bind:darkMode="true"-->
  <!--          isBtn="bg-gradient-success"-->
  <!--        />-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row ">
            <div
                class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute start-0 justify-content-center flex-column"
            >
              <div
                  class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                  :style="{ backgroundImage: `url(${loginImage})`, backgroundSize: 'cover',backgroundPosition: 'center' }"
              >
                <!--                <span class="mask opacity-6 bg-gradient-faded-dark"></span>-->

                <!--                <div class="border-radius-xl bg-gradient-faded-danger">-->
                <!--                  <h4-->
                <!--                      class="mt-5 text-white font-weight-bolder position-relative"-->
                <!--                  >-->
                <!--                    "مجتمع چاپ لابیران"-->
                <!--                  </h4>-->
                <!--                  <p class="text-white position-relative">-->
                <!--                    چاپ عکس با بالاترین کیفیت در سریعترین زمان ممکن.-->
                <!--                  </p>-->
                <!--                </div>-->
              </div>
            </div>
            <div
                class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header ">
                  <h4 class="font-weight-bolder">ورود به حساب کاربری</h4>
                  <p class="mb-0">نام کاربری و رمز عبور خود را برای ورود وارد کنید</p>
                </div>
                <div class="card-body">
                  <form role="form">
                    <div class="mb-3">
                      <argon-input
                          id="email"
                          type="email"
                          dir="ltr"
                          placeholder="Email"
                          name="email"
                          size="lg"
                      />
                    </div>
                    <div class="mb-3">
                      <argon-input
                          id="password"
                          type="password"
                          dir="ltr"
                          placeholder="Password"
                          name="password"
                          size="lg"
                      />
                    </div>
                    <argon-switch id="rememberMe" name="remember-me"
                    >مرا بخاطر بسپار
                    </argon-switch
                    >

                    <div class="text-center">
                      <argon-button
                          class="mt-4"
                          variant="gradient"
                          color="success"
                          fullWidth
                          size="lg"
                      >ورود
                      </argon-button
                      >
                    </div>
                  </form>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <router-link :to="{name:'signin-otp'}">
                    <p class="mx-auto mb-2 text-sm">
                      <i class="fa fa-mobile-alt mt-1 fa-lg position-relative ms-1"></i>
                      <b> ورود با موبایل</b>
                    </p>
                  </router-link>
                </div>

                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    حساب کاربری ندارید؟
                    <a
                        href="javascript:;"
                        class="text-success text-gradient font-weight-bold"
                    >ثبت نام</a
                    >
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </main>
</template>
